import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IDynamicFileMangementTemplate,
  IDynamicFileMangementTemplateEditSession,
  IDropdownResponse,
  IDynamicFileMangementTemplateDetail,
  IDynamicFileManagementTemplateType
} from '../models';

const baseUrl = '/api/documentation/dynamic-file-management/templates';

export const getDynamicDocumentationFileTemplates = async (): Promise<IDynamicFileManagementTemplateType[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}`);
    return data;
  } catch (error) {
    logError(error, 'getDynamicDocumentationFiles failed');
    return Promise.reject(error);
  }
};

export const getDynamicDocumentationFileTemplatesRecent = async (
  documentName: string
): Promise<IDynamicFileMangementTemplate[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/recent?documentName=${documentName}`);
    return data;
  } catch (error) {
    logError(error, 'getDynamicDocumentationFileTemplatesRecent failed');
    return Promise.reject(error);
  }
};

export const getDynamicDocumentationFileTemplatesHistory = async (
  documentName: string
): Promise<IDynamicFileMangementTemplate[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/history?documentName=${documentName}`);
    return data;
  } catch (error) {
    logError(error, 'getSalesToolsContractHistory failed');
    return Promise.reject(error);
  }
};

export const uploadDynamicDocumentationFileTemplate = async (payload: FormData): Promise<any> => {
  try {
    const { data } = await axios.post(`${baseUrl}`, payload);
    return data;
  } catch (error: any) {
    logError({ error, payload }, 'uploadDynamicDocumentationFileTemplate failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getEditDynamicDocumentationFileTemplateSession = async (
  pandaDocTemplateId: string
): Promise<IDynamicFileMangementTemplateEditSession> => {
  try {
    const { data } = await axios.post(`${baseUrl}/${pandaDocTemplateId}/sessions`);
    return data;
  } catch (error: any) {
    logError(
      { error, payload: { pandaDocTemplateId } },
      'getEditDynamicDocumentationFileTemplateSession failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getDynamicDocumentationFileEditTemplateTokens = async (): Promise<
  IDropdownResponse[]
> => {
  try {
    const { data } = await axios.get(`${baseUrl}/tokens`);
    return data;
  } catch (error) {
    logError(error, 'getDynamicDocumentationFileEditTemplateTokens failed');
    return Promise.reject(error);
  }
};

export const getDynamicDocumentationFileTemplatesFinancingTypes = async (): Promise<
  IDropdownResponse[]
> => {
  try {
    const { data } = await axios.get(`${baseUrl}/financing-types`);
    return data;
  } catch (error) {
    logError(error, 'getDynamicDocumentationFileTemplatesFinancingTypes failed');
    return Promise.reject(error);
  }
};

export const getDynamicDocumentationFileTemplate = async (
  pandaDocTemplateId: string
): Promise<IDynamicFileMangementTemplateDetail> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${pandaDocTemplateId}/info`);
    return data;
  } catch (error) {
    logError(error, 'getDynamicDocumentationFileTemplate failed');
    return Promise.reject(error);
  }
};

export const updateDynamicDocumentationFileTemplate = async (
  pandaDocTemplateId: string,
  payload: {
    financingTypes?: string[];
    isActive?: boolean;
  }
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${pandaDocTemplateId}`, payload);
    return data;
  } catch (error) {
    logError(error, 'updateDynamicDocumentationFileTemplate failed');
    return Promise.reject(error);
  }
};

export const createPdfFromBuildDocTemplate = async (pandaDocTemplateId: string): Promise<void> => {
  try {
    await axios.post(`${baseUrl}/${pandaDocTemplateId}/create-pdf`);
  } catch (error) {
    logError(error, 'createPdfFromBuildDocTemplate failed');
    return Promise.reject(error);
  }
};